import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FieldEditorV2Component } from '../../base-template-editor-v2/field-editor-v2/field-editor-v2.component';
import { InlineEditV2Directive } from '../../base-template-editor-v2/inline-edit/inline-edit-v2.directive';
import { BaseComponent } from '../../common/BaseComponent';
import { Helper } from '../../../../utils/helper';
import {
  HeadingInitModel,
  HeadingInitVariables,
  HeadingModel,
  HeadingVariables,
} from '../../../../models/email-template/heading.interface';

/**
 * Mockup-styled Big Headline block - a drop-in replacement for app-heading in
 * block-renderer-v2 (same [block]/[isPreview] inputs and outputs), so it
 * covers both the center-canvas summary (isPreview=true) and the
 * right-panel edit form (isPreview=false). Reuses the real, unmodified
 * app-field-editor-v2 and app-pin sub-components and the exact same
 * HeadingVariables field name - only the surrounding layout is new. Comments
 * are reachable via the separate Comments tab (see edit-block-comments-v2),
 * same as Main Banner/Intro + CTA.
 */
@Component({
  selector: 'app-heading-v2',
  imports: [CommonModule, ReactiveFormsModule, FieldEditorV2Component, InlineEditV2Directive],
  templateUrl: './heading-v2.component.html',
  styleUrl: './heading-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class HeadingComponentV2 extends BaseComponent implements OnInit {
  @Input() block: HeadingModel = new HeadingInitModel();
  @Input() isPreview = false;
  @Input() disabled = false;

  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new HeadingInitVariables();
    }
  }

  headingPlaceholder = 'Enter Heading Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof HeadingVariables) {
    if (this.block.variables) {
      (this.block.variables as any)[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }
}
